<script setup lang="ts">
defineOptions({ name: 'LoadingProgress' })

defineProps<{
  visible: boolean
  percent: number
}>()
</script>

<template>
  <!-- 路由资源加载进度：固定在页面顶部，不阻断当前页面交互 -->
  <div
    class="fixed top-0 left-0 right-0 z-[10000] h-1 pointer-events-none transition-opacity duration-200"
    :class="visible ? 'opacity-100' : 'opacity-0'"
    aria-hidden="true"
  >
    <div
      class="h-full bg-brand transition-all duration-200 ease-out"
      :style="{ width: `${percent}%` }"
    />
  </div>
</template>
